import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

const selectors = {
  sliderContainer: '[data-announcement-container]',
  slide: '[data-announcement]',
  closeButton: '[data-close-announcement-bar]',
};

const classes = {
  hide: 'hide',
  hasAnnouncement: 'has-announcement-bar',
};

const sectionType = 'announcement';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;
      const sectionLocation = container.dataset.sectionLocation;
      this.showAnnouncement = true;

      if (sectionLocation === 'header') {
        this.showAnnouncement = false;
        this.checkSessionStorage();
        this.setAnnouncementHeightVar();
      }

      if (!this.showAnnouncement) return;
      const slider = container.querySelector(selectors.sliderContainer);
      if (!slider) return;

      container.classList.remove(classes.hide);
      const sectionWidth = container.offsetWidth;
      const closeButton = container.querySelector(selectors.closeButton);

      let flickity;
      let requestId;

      const initialSlidesArray = slider.querySelectorAll(selectors.slide);
      const initialLengthOfSlidesArray = initialSlidesArray.length;

      const flickityOptions = {
        freeScroll: true,
        freeScrollFriction: 0.03,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        percentPosition: true,
      };

      const resetSliderWithOriginalSlides = () => {
        slider.innerHTML = '';
        initialSlidesArray.forEach((slide) => {
          slider.appendChild(slide);
        });
      };

      const slidesExtendOutsideViewport = () => {
        const newSlides = Array.from(slider.querySelectorAll(selectors.slide));
        const carouselWidth = newSlides[initialLengthOfSlidesArray - 1].getBoundingClientRect().right;
        return carouselWidth > sectionWidth;
      };

      const duplicateSlides = () => {
        const slides = slider.querySelectorAll(selectors.slide);
        slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          slider.appendChild(clone);
        });
      };

      const fillMarqueeWithSlides = () => {
        const slides = slider.querySelectorAll(selectors.slide);
        const carouselWidth = slides[slides.length - 1].getBoundingClientRect().right;
        const amountOfTimesToDuplicate = Math.ceil(sectionWidth / carouselWidth);
        if (amountOfTimesToDuplicate < 1) return;
        for (let i = 0; i < amountOfTimesToDuplicate; i++) {
          slides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            slider.appendChild(clone);
          });
        }
      };

      const reInitFlickity = () => {
        flickity = new Flickity(slider, flickityOptions);
        flickity.x = 0;
      };

      flickity = new Flickity(slider, flickityOptions);

      initMarquee();

      window.addEventListener('resize', initMarquee);

      function initMarquee() {
        if (!flickity) return;

        // First reset everything & return the slider to the original state
        flickity.destroy();
        window.cancelAnimationFrame(requestId);
        requestId = null;
        resetSliderWithOriginalSlides();

        // First ensure that the marquee is full of slides
        fillMarqueeWithSlides();

        if (slidesExtendOutsideViewport()) {
          // We then need to duplicate the slides to get around a fickity bug that causes a gap at the start of the marquee.
          duplicateSlides();
          reInitFlickity();
          play();
        } else {
          fillMarqueeWithSlides();
          // We then need to duplicate the slides to get around a fickity bug that causes a gap at the start of the marquee.
          duplicateSlides();
          reInitFlickity();
          play();
        }
      }

      function play() {
        flickity.x -= 1.5;
        flickity.settle(flickity.x);
        requestId = window.requestAnimationFrame(play);
      }

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          container.classList.add(classes.hide);
          sessionStorage.setItem('announcementBar', 'hide');
          flickity.destroy();
          window.removeEventListener('resize', initMarquee);
          this.setAnnouncementHeightVar();
          document.body.classList.remove(classes.hasAnnouncement);
          document.dispatchEvent(new CustomEvent('announcement-bar-hide'));
        });
      }
    },

    checkSessionStorage() {
      const announcementBarStorage = sessionStorage.getItem('announcementBar');

      if (!announcementBarStorage) {
        this.showAnnouncement = true;
        document.body.classList.add(classes.hasAnnouncement);
      }
    },

    setAnnouncementHeightVar() {
      window.requestAnimationFrame(() => {
        const announcementHeight = this.container.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
      });
    },
  });
